import { z } from 'zod';

export const paymentAccountType = z.enum(['ach', 'domestic_wire', 'cheque', 'international_wire']);

export type PaymentAccountType = z.infer<typeof paymentAccountType>;

export const paymentAccountTypeToLabel = {
  [paymentAccountType.enum.ach]: 'ACH',
  [paymentAccountType.enum.domestic_wire]: 'Domestic Wire',
  [paymentAccountType.enum.cheque]: 'Cheque',
  [paymentAccountType.enum.international_wire]: 'International Wire',
};
